module.exports = __webpack_public_path__ + "static/tiled-sand-bkg-ac3230c9301879845440b94b5a0790cd.jpg";